import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";
import {NewsFactory} from "./news.factory";

export class NewsApi extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, NewsFactory];
}
